import { render } from "./DropdownButton.vue?vue&type=template&id=5ddfb018&scoped=true&ts=true"
import script from "./DropdownButton.vue?vue&type=script&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&lang=ts"

import "./DropdownButton.vue?vue&type=style&index=0&id=5ddfb018&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddfb018"]])

export default __exports__